module.exports = __webpack_public_path__ + "img/Sokchanlida.894ba407.png";